var $name="mouseButtons",$path="configs/mouseButtons.js",$this={$name,$path,};module.exports = {
  middle: 1,
};
